import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useState } from 'react';
import { useIoContext } from '~/contexts';
const LEAVE_MS = 120;
const ENTER_MS = 280;
export const useOpportunityDeckMotion = (card)=>{
    var _motion_leavingCard;
    const { browser } = useIoContext();
    const [motion, setMotion] = useState({
        identity: card.identity,
        card,
        leavingCard: null,
        phase: 'still'
    });
    if (motion.identity !== card.identity) {
        var _motion_leavingCard1;
        const animate = !browser.prefersReducedMotion();
        setMotion({
            identity: card.identity,
            card,
            leavingCard: animate ? (_motion_leavingCard1 = motion.leavingCard) !== null && _motion_leavingCard1 !== void 0 ? _motion_leavingCard1 : motion.card : null,
            phase: animate ? 'leaving' : 'still'
        });
    }
    useEffect(()=>{
        if (motion.phase === 'leaving') {
            return browser.schedule(LEAVE_MS, ()=>setMotion((current)=>_object_spread_props(_object_spread({}, current), {
                        leavingCard: null,
                        phase: 'entering'
                    })));
        }
        if (motion.phase === 'entering') {
            return browser.schedule(ENTER_MS, ()=>setMotion((current)=>_object_spread_props(_object_spread({}, current), {
                        phase: 'still'
                    })));
        }
    }, [
        motion.phase,
        motion.identity
    ]);
    return {
        shownCard: (_motion_leavingCard = motion.leavingCard) !== null && _motion_leavingCard !== void 0 ? _motion_leavingCard : card,
        isLeaving: motion.phase === 'leaving',
        isEntering: motion.phase === 'entering'
    };
};
